<template>    
    <keep-alive>        
        <component 
            :is="mainform"
            :formdata="formdata"  
            v-on:submitcomplete="onSubmitComplete"
        ></component>
    </keep-alive>
</template>
<script>
    import { mapGetters } from 'vuex';
    import mainform from "../components/forms/MainForm.vue";
    export default {   
    
    props: [
        
    ],
    components: {
        mainform:"mainform"
    },
    data() {
        return {  
            mainform:mainform,
                    
        }
    },
    computed: {
        ...mapGetters({
            formdata: 'tagcategories/formdata',
            entities: 'tagcategories/tagcategories'
        }),
        routeid(){return this.$route.params.id}
    },
    methods: {
        onSubmitComplete: function(submitted, id){   
                                    
            if(!submitted) {
                this.$router.push({ 
                name: 'entities'})
                
            } else {
                this.$router.push({ 
                name: 'tagcategories_update', 
                params: { 
                        id: id 
                }})
            }
        },
        async init(){
            
            await this.$store.dispatch('tagcategories/getAll')    

            if(typeof this.routeid != 'undefined') {   
                await this.$store.dispatch('tagcategories/getById', this.routeid)
            }
        }
    },
    mounted() {
        this.init()
        
    }
    
    
}
</script>